import { render, staticRenderFns } from "./SetPoint.vue?vue&type=template&id=647c3fc2&scoped=true&"
import script from "./SetPoint.vue?vue&type=script&lang=js&"
export * from "./SetPoint.vue?vue&type=script&lang=js&"
import style0 from "./SetPoint.vue?vue&type=style&index=0&id=647c3fc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647c3fc2",
  null
  
)

export default component.exports